import { HttpInterceptorFn } from '@angular/common/http';
import { whiteLabelTarget } from '../utils/whiteLabel';

export const WhiteLabelInterceptor: HttpInterceptorFn = (req, next) => {
  const whiteLabel = whiteLabelTarget;

  if (!whiteLabel) return next(req);

  return next(req.clone({ setParams: { isWhiteLabel: whiteLabel?.target } }));
};
